module.exports = __webpack_public_path__ + "img/partner_icon23.ff7e50e6.png";